<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group has-label">
          <label>Datum</label>
          <el-date-picker
            v-model="date"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            @change="fetchData"
            :clearable="false"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </div>
        <div class="form-group has-label">
          <label>Lager</label>
          <multiselect v-model="selectedWarehouses"
            :options="warehouses"
            track-by="id"
            label="short_name"
            :multiple="true"
            placeholder="Lager filtern..."
          />
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <div v-if="! loading">
        <warehouse-value
          v-for="warehouse in filteredWarehouses" :key="warehouse.id"
          :warehouse="warehouse"
          @openProducts="openProducts"
          :product-categories="productCategories"
        />
      </div>
    </transition>
    <warehouse-products-value-dialog
      :products="warehouseProducts"
      :show="showDialog"
      @close="showDialog = false"
    />
  </div>
</template>

<script>
import WarehouseValue from './warehouse-value'
import WarehouseProductsValueDialog from './warehouse-products-value-dialog'
import { DatePicker } from 'element-ui'
import moment from 'moment'

export default {
  components: {
    WarehouseValue,
    WarehouseProductsValueDialog,
    [DatePicker.name]: DatePicker
  },
  data () {
    return {
      date: moment().format('YYYY-MM-DD'),
      loading: true,
      warehouses: [],
      warehouseProducts: [],
      showDialog: false,
      productCategories: [],
      selectedWarehouses: this.$store.state.filters.warehouse ? [this.$store.state.filters.warehouse] : [],
      selectedCategory: null
    }
  },
  methods: {
    openProducts ({ warehouse, productCategory }) {
      let url = ''

      if (productCategory) {
        url = `/stats/warehouses/${warehouse}/product_categories/${productCategory}?date=${this.date}`
      } else {
        url = `/stats/warehouses/${warehouse}/product_categories/for_null?date=${this.date}`
      }

      this.$http.get(url).then(({ data }) => {
        this.warehouseProducts = data
        this.showDialog = true
      })
    },
    fetchData () {
      this.$http.get(`/stats/warehouses?date=${this.date}`).then(({ data }) => {
        this.loading = false
        this.warehouses = data
      })
      this.$http.get('/parent_product_categories').then(({ data }) => {
        data.push({ name: 'Ohne Warengruppen', id: '', child_categories: [] })
        this.productCategories = data
      })
    }
  },
  computed: {
    filteredWarehouses () {
      return this.warehouses.filter(warehouse => {
        if (this.selectedWarehouses.length) {
          return this.selectedWarehouses.some(fw => fw.id === warehouse.id)
        }
        return true
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
